angular.module('component-localization', [])
    .service('Localization', LocalizationService);

LocalizationService.$inject = ['$rootScope', '$translate', 'tmhDynamicLocale', 'Storage', 'Notification'];



function LocalizationService($rootScope, $translate, tmhDynamicLocale, Storage, Notification) {

    var service = {
        active: 'ua',
        // langs: ['ua', 'ru','en'],
        langs: {
            ua: 'Українська',
            // ru: 'Русский',
            en: 'English'
        },
        init: function() {
            service.initLang(Storage.getItem('lang'));
        },
        setLang: function(lang) {
            lang = service.initLang(lang);

            Storage.setItem('lang', lang);
            $rootScope.$broadcast('changeLang', { lang: lang });

        },
        initLang: function (lang) {
            lang = service.validateLang(lang);

            service.active = lang;
            tmhDynamicLocale.set(lang);
            $translate.use(lang);

            return lang;
        },
        validateLang: function(lang) {
            var langs = Object.keys(service.langs);
            return langs.indexOf(lang) === -1 ? langs[0] : lang;
        },
        /*notify template*/
        /* to show notify input
            Localization.notifyTemplate('type', 'text', 1, true);
            params:
             -'type'. string(info, warning, error, success..)
             -'text'. string from locale file
             -delay. number. in seconds(1,2,3,4...)
             -replaceMessage. boolean. to delete old messages
             -scopetext. additional text frome $scope
         */
        notifyTemplate: function (type, text, delay, replace, scopetext) {
            return $translate(text).then(function (translation) {
                var message = scopetext ? translation + scopetext : translation;
                
                Notification({
                    message: message,
                    delay: 1000 * delay
                }, type);
                
                service.announceToScreenReader(message, type);
            });
        },
        /*end notify template*/
        
        announceToScreenReader: function(message, type) {
            var isUrgent = type === 'error' || type === 'warning';
            var regionId = isUrgent ? 'sr-alert-region' : 'sr-live-region';
            var region = document.getElementById(regionId);
            
            if (region) {
                region.textContent = '';
                
                setTimeout(function() {
                    region.textContent = message;
                }, 100);
                
                setTimeout(function() {
                    region.textContent = '';
                }, 3000);
            }
        }
        /*end announce to screen reader*/

    };

    service.init();

    return service;
}

module.exports = 'component-localization';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/localization/index.js
 ** module id = 109
 ** module chunks = 1
 **/